import { useSelector } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

import { client } from 'graphql/apollo';

import { CustomizationReducerState, CustomizationReducer } from 'store/interfaces';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector<CustomizationReducerState, CustomizationReducer>((state) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <ApolloProvider client={client}>
        <ThemeProvider theme={themes(customization)}>
          <CssBaseline />
          <NavigationScroll>
            <Routes />
          </NavigationScroll>
        </ThemeProvider>
      </ApolloProvider>
    </StyledEngineProvider>
  );
};

export default App;
